<div class="container py-5 text-center">
    <h4>Completing Microsoft sign-in...</h4>
    <p>Please wait while we sign you into AIC One.</p>
</div>